export const INSTAGRAM_LINK = "https://www.instagram.com/blazing_paddles/";
export const YOUTUBE_LINK = "https://www.youtube.com/@BlazingPaddlesDragonboat";
export const MAPS_LINK = "https://maps.app.goo.gl/PqU2XyAgU3kZPM6C6";
export const FB_LINK =
    "https://www.facebook.com/people/Blazing-Paddles-BrowardPalm-Beach-Floridas-Dragon-Boat-and-Canoe-Team/100057269874008/";

export const PAYPAL_LINK = "https://www.paypal.com/paypalme/SynergySeries"
export const SOAR_LINK = "https://www.soarteam.com"